import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ExternalLink, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { getTramite } from '@/services/tramiteService';
import type { EscrituraImportada } from '../types';

interface EnlaceEscrituraProps {
  escritura: EscrituraImportada;
  className?: string;
}

/** La escritura se identifica siempre por su id. */
export const etiquetaEscritura = (escritura: EscrituraImportada): string =>
  `#${escritura.tramiteId}`;

/**
 * Enlace a la escritura en la que se importó el presupuesto.
 *
 * El dashboard de una escritura se abre con el trámite completo en el state de
 * la navegación (ver `useCurrentTramite`), así que hay que traerlo antes de
 * navegar; desde acá solo tenemos su id.
 */
export const EnlaceEscritura: React.FC<EnlaceEscrituraProps> = ({
  escritura,
  className = '',
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cargando, setCargando] = useState(false);

  const abrir = async () => {
    setCargando(true);

    try {
      const tramite = await getTramite({ id: escritura.tramiteId });
      // `from` hace que el botón de volver de la escritura regrese al presupuesto.
      navigate('/dashboard', {
        state: { tramite, from: `${location.pathname}${location.search}` },
      });
    } catch {
      toast.error('No se pudo abrir la escritura.');
      setCargando(false);
    }
  };

  return (
    <button
      type="button"
      onClick={() => void abrir()}
      disabled={cargando}
      title={
        escritura.numregistro
          ? `Abrir la escritura (registro ${escritura.numregistro})`
          : 'Abrir la escritura donde se importó este presupuesto'
      }
      className={`inline-flex items-center gap-1 rounded text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50 ${className}`}
    >
      {cargando ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <ExternalLink className="h-3.5 w-3.5" />
      )}
      {etiquetaEscritura(escritura)}
    </button>
  );
};
